import handler from '../handler/handler';
import messages from '../handler/messages/messages';

const statusHandler = handler(messages);

export default {
  state: {
    grapes: null,
  },
  getters: {
    getGrapeList: state => state.grapes,
  },
  mutations: {
    successGrapes: (state, payload) => {
      state.grapes = payload;
    },
  },
  actions: {
    getGrapeList: async ({ commit, getters }) => {
      const result = await statusHandler.authGet({ commit, getters }, '/api/grapes/');

      commit('successGrapes', result.response.result.rows);
      return result.response.result.rows;
    },

    updateGrape: async ({ commit, getters }, data) => {
      const grape = {
        id: data.id,
        name: data.name,
        name_en: data.nameEn,
        grape_dsc_subtitle: data.grapeDscSubtitle,
        grape_dsc: data.grapeDsc,
        img_grape: data.imgGrape,
        is_checked: data.isChecked,
      };

      const result = await statusHandler.authPut({ commit, getters }, `/api/grapes/${grape.id}`, grape);
      return result;
    },

    createEmptyGrape: async ({ commit, getters }) => {
      const result = await statusHandler.authPost({ commit, getters }, '/api/grapes/');
      return result;
    },

    deleteGrape: async ({ commit, getters }, id) => {
      const result = await statusHandler.authDelete({ commit, getters }, `/api/grapes/${id}`);
      return result;
    },

    deleteGrapes: async ({ commit, getters }, ids) => {
      const result = await statusHandler.authPatch({ commit, getters }, '/api/grapes/delete', ids);
      return result;
    },
  },
};



// WEBPACK FOOTER //
// ./src/vuex/modules/grape.js